import React from "react";
import Card from "../Card/Card";
import './Services.css'
import HeartEmoji from '../../img/heartemoji.png';
import Glasses from '../../img/glasses.png';
import Humble from '../../img/humble.png';
import { themeContext } from "../../Context";
import { useContext } from "react";
import {motion} from 'framer-motion';
import Resume from './resume.pdf';
const Services =() =>{

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const transition ={duration : 1, type: 'spring'}

    return(
        <div className="services" id='Services'>

              {/* Left side*/}
        <div className="awesome">
        <span style={{color: darkMode? 'white': ''}}>My Awesome</span>
        <span>services</span>
        <span>
             Lorem ispum is simpley dummy text of printing of printing Lorem
             <br/>
             ispum is simpley dummy text of printing
         </span>
             
             <a href={Resume} download>
             <button className="button s-button">Downloade CV</button>
             </a>
    
         <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
            </div>

            {/* right side*/}
            <div className="cards">

            {/* First Card*/}
            <motion.div 
            initial={{left: '25%'}}
            whileInView={{left: '14rem'}}
            transition={transition}           
            
            style={{left: '14rem'}}>
                <Card
                emoji = {HeartEmoji}
                heading = {'Design'}
                detail = {"Figma, Sketch, Photoshop, Adobe, Adobe xd, UX/UI-- "}
                />
             </motion.div>


             {/* Second Card*/}
             <motion.div 
             
            initial={{top: '12rem' , left: '-76%'}}
            whileInView={{ left: '-4rem'}}
            transition={transition}

             style={{ top: "14rem", left: '-4rem'}}>
                <Card
                emoji = {Glasses}
                heading = {'Developer'}
                detail = {"Html, Css, Javascript, React,Html, Css, Javascript, React"}
                />
             </motion.div>
             
                  {/* Third Card*/}
             <motion.div
             
            initial={{top: '19rem', right: '74%'}}
            whileInView={{left: '15rem'}}
            transition={transition}
             
             style={{top: "19rem", left: '12rem'}}>
                <Card
                emoji = {Humble}
                heading = {'UI/UX'}
                detail = {"Lorem ispum dummy text are usually use in section where we need some random text"}
                />

            <div className="blur s-blur2" style={{background: "rgb(236 210 255)"}}> </div>        

             </motion.div>

            </div>
        </div>

    );
}

export default Services;